import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { HttpClient } from '@angular/common/http';
import { ProductRating } from '../models/productAuth';
@Injectable({
  providedIn: 'root'
})
export class RazzleDazzleService {
  url;
  constructor(private sharedService: SharedService, private httpClient: HttpClient) {
    this.url = sharedService.baseURL;
  }

  createRazzleDazzleUser(userData: any): any {
    return this.httpClient.post<any>(`${this.url}/api/RazzleDazzle/CreateRazzleDazzleUser`, userData);
  }
}
